export async function recordOrdersExport(token, rowCount, filters = {}) {
    const response = await fetch('/api/orders/exports/audit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ rowCount, filters }),
    })
    if (!response.ok) {
        const data = await response.json().catch(() => ({}))
        throw new Error(data.message || 'Не удалось зафиксировать экспорт')
    }
}
